module.exports = "/_next/static/images/6324a876b6b8bf3754cccb88c00a2d5a-hero-variant-lg.png";